module.exports = "/images/Azul_Express_v2.png?70555db0b13da8e4c125a71e0228f2b3";